module.exports = __webpack_public_path__ + "img/logoHands.06c67695.png";